import get from 'lodash.get';

export const selectCategories = (state) => get(state, 'category.categories');
